//import logo from './logo.svg';
import React from 'react';

import './App.css';
import './terminal.css';
import './section.css';
import './responsive.css';
import Terminal from './terminal';
import DarkModeToggle from './ModeVisual';
import MenuHamburger from './MenuHamburger';
import OngletsExp from './OngletsExp';
import ContactForm from './ContactForm';

function App() {
  return (
    <div className="App">
      <header className="header">
        <MenuHamburger/>
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        <nav className="nav">
          <ul class="nav-list">
                <li><a href="#accueil" class="nav-link">Accueil</a></li>
                <li><a href="#experiences" class="nav-link">Mes expériences</a></li>
                <li><a href="#formations" class="nav-link">Formations</a></li>
                <li><a href="#projets" class="nav-link">Mes projets</a></li>
                <li><a href="#contact" class="nav-link">Contact</a></li>
          </ul>
           <ul class="mobile-nav">
                <li><a href="#accueil" class="mobile-nav-link">Accueil</a></li>
                <li><a href="#experiences" class="mobile-nav-link">Mes Expériences</a></li>
                <li><a href="#formations" class="mobile-nav-link">Formations</a></li>
                <li><a href="#projets" class="mobile-nav-link">Mes Projets</a></li>
                <li><a href="#contact" class="mobile-nav-link">Me Contacter</a></li>
            </ul>
        </nav>
        <div class="dark-mode-toggle">
            <DarkModeToggle/>
        </div>
      </header>

      <section id="accueil" className="section">
         <h1>Bienvenue sur mon portfolio</h1>
        <div class="content-container contentTerminal">
            <Terminal />
        </div>
      </section>

      <section id="experiences" class="section">
        <h2>Mes Expériences</h2>
        <div class="content-container">
            <OngletsExp/>
        </div>
    </section>

     <section id="formations" class="section">
        <h2>Formations</h2>
        <div class="content-container">
            <div class="formations-container">
                <div class="formation-card glass-effect">
                    <h3>École : L'IDEM Creative Arts School</h3>
                    <p><strong>Intitulé :</strong> Licence en Informatique</p>
                    <p><strong>Durée :</strong> 2018 - 2021</p>
                    <p><strong>Pôles étudiés :</strong> Administration système, Réseaux, Haute Disponibilité, Gestion des risques cyber, Gestion de projet, Forensique</p>
                </div>
                <div class="formation-card glass-effect">
                    <h3>École : IMERIR</h3>
                    <p><strong>Intitulé :</strong> Licence Informatique et Robotique de prototypage</p>
                    <p><strong>Durée :</strong> 2023 - 2024</p>
                    <p><strong>Pôles étudiés :</strong> Administration système, Réseaux, Prototypage, Programmation Orientée Objet, Programmation robot</p>
                </div>
                <div class="formation-card glass-effect">
                    <h3>École : IMERIR</h3>
                    <p><strong>Intitulé :</strong> Classe préparatoire (Développeur Intégrateur de Solution Intranet/Internet)</p>
                    <p><strong>Durée :</strong> 2020 - 2023</p>
                    <p><strong>Pôles étudiés :</strong> Réseaux, Électronique, Administration système, Developpement web, Programmation Python, C, Algorithmique, Impression 3D et Modélisation numérique</p>
                </div>
            </div>
        </div>
    </section>

    <section id="projets" class="section">
        <h2>Mes Projets</h2>
        <div class="content-container glass-effect">
            <p>Contenu à ajouter...</p>
        </div>
    </section>

    <section id="contact" class="section">
        <h2>Me Contacter</h2>
        <ContactForm/>
    </section>
    <footer class="footer">
        <p>© 2026 - Tous droits réservés</p>
    </footer>
    </div>
  );
}

export default App;
